<div class="surface-0">
  <div
    class="flex align-items-center justify-content-between flex-column h-screen"
  >
    <div
      class="flex flex-column align-items-center justify-content-center w-full md:w-4 h-full text-center py-6 px-6"
    >
      <a [routerLink]="['/']" class="mb-6" aria-label="Μετάβαση στην αρχική σελίδα">
        <!-- <img src="../../assets/layout/images/phi-logo.png" class="w-16rem"> -->
        <!-- <img src="../../assets/layout/images/phi_eurolife.png" class="w-10rem"> -->
        <img src="../../assets/layout/images/phidelity_logo.png" alt="PHI" class="w-10rem">
        <!-- <img
          src="../../assets/layout/images/phi_easfalistiki.png"
          class="w-10rem"
        /> -->
      </a>
      <div class="flex flex-column">
        <p-iconfield class="w-full mb-4">
          <p-inputicon styleClass="pi pi-envelope" />
          <label for="email" class="sr-only">Email</label>
          <input
            id="email"
            type="email"
            autocomplete="email"
            pInputText
            class="w-full md:w-25rem text-color-secondary surface-50 border-200"
            placeholder="Email"
            [(ngModel)]="email"
          />
        </p-iconfield>
        <p-iconfield class="w-full mb-4">
          <p-inputicon styleClass="pi pi-lock" />
          <label for="password" class="sr-only">{{ 'LOGIN.PASSWORD' | translate }}</label>
          <input
            id="password"
            type="password"
            autocomplete="current-password"
            pInputText
            class="w-full md:w-25rem text-color-secondary surface-50 border-200"
            placeholder="{{ 'LOGIN.PASSWORD' | translate }}"
            [(ngModel)]="password"
          />
        </p-iconfield>
        @if(formHasError){
        <div class="w-full md:w-25rem text-red-400 mb-2">
          {{ errorMessage | translate }}
        </div>
        }
        <button
          pButton
          pRipple
          class="w-full mb-4"
          [disabled]="submitted"
          (click)="login()"
        >{{ 'LOGIN.LOGIN' | translate }}</button>
        <a href="#" class="font-medium text-sm text-600">{{  
          "LOGIN.FPASSWORD" | translate
        }}</a>
        <p class="font-medium text-700 m-0 mt-3">
          {{ "LOGIN.ACCOUNT" | translate }},
          <a [routerLink]="['/register']" class="text-primary cursor-pointer underline">{{
            "LOGIN.SIGNUP" | translate
          }}</a>
        </p>
      </div>

      <div class="mt-5">
        <button
          type="button"
          (click)="toggleDropdown()"
          style="border: none; background: transparent; cursor: pointer"
        >
          <img
            [src]="selectedLanguageIcon"
            alt="Selected Language"
            style="width: 20px; height: auto"
          />
        </button>

        @if (dropdownVisible) {
        <div class="dropdown-menu" style="position: absolute; z-index: 1000">
          @for (lang of languages; track lang) {
          <button
            type="button"
            (click)="switchLanguage(lang.value)"
            style="
              display: flex;
              align-items: center;
              cursor: pointer;
              padding: 0 0 5px 5px;
              background: none;
              border: none;
              width: 100%;
            "
          >
            <img
              [src]="lang.icon"
              alt="{{ lang.label }}"
              style="width: 15px; height: auto; margin-right: 5px"
            />
            {{ lang.label }}
          </button>
          }
        </div>
        }
      </div>
    </div>

    <div class="flex flex-wrap align-items-center pb-8 px-4">
      <h4 class="m-0 mr-5" style="line-height: 22px">PHI</h4>
      <!-- <h6 class="m-0 font-medium text-300" style="line-height: 17px">Copyright Ⓒ Covariance P.C.</h6> -->
    </div>
  </div>
</div>
